import { getLeadEvalToken } from 'app-requests/triadmsRequests';
import { FIELD_NAMES, VALIDATION_TYPES } from 'consts';
import { useEffect } from 'react';
import FIELD_VALIDATION_MAP from 'utils/fieldValidations';
import { LogError } from 'utils/logging/LogError';

export async function shouldRequestLeadEvalToken(formValues, isLastStep) {
  if (!isLastStep) {
    return false;
  }

  const primaryNumber = formValues[FIELD_NAMES.PRIMARY_PHONE];
  const phoneValidation = FIELD_VALIDATION_MAP[VALIDATION_TYPES.PHONE];

  const phoneNumberResult = await phoneValidation({
    value: primaryNumber,
    name: FIELD_NAMES.PRIMARY_PHONE,
    formValues,
  });

  const isPrimaryPhoneValid = !phoneNumberResult[FIELD_NAMES.PRIMARY_PHONE];
  const isSecondaryPhoneValid = !phoneNumberResult[FIELD_NAMES.SECONDARY_PHONE];

  if (!primaryNumber || !isPrimaryPhoneValid) {
    return false;
  }

  if (!isSecondaryPhoneValid) {
    return false;
  }

  return true;
}

export function LeadEvalTokenRequestSideEffect({ formState, actions }) {
  const {
    formStatus: { leadEvalToken },
    formValues,
    fieldNameMap,
    formConfigs: { schoolCode },
    isLastStep,
  } = formState;

  /**
   * Asynchronously handles the update of lead evaluation token.
   */
  async function handleLeadEvalTokenUpdate() {
    const leadTokenResponse = await getLeadEvalToken(
      formValues,
      fieldNameMap,
      schoolCode
    ).catch((error) => {
      LogError('Error fetching leadEvalToken:', error);
    });

    actions.setStatus({
      leadEvalToken: leadTokenResponse?.leadEvalToken,
    });
  }

  useEffect(() => {
    // TODO [FSIU-75]: Find a way to implement isFormCompleteAndValid
    const timeout = setTimeout(async () => {
      const shouldRequestToken = await shouldRequestLeadEvalToken(
        formValues,
        isLastStep
      );

      if (shouldRequestToken) {
        handleLeadEvalTokenUpdate();
        return;
      }

      if (leadEvalToken) {
        actions.setStatus({ leadEvalToken: null });
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [formValues]);

  return null;
}
